import React from "react";
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Switch,
  Text,
  useColorModeValue,
  PinInput,
  PinInputField,
  HStack,
} from "@chakra-ui/react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import Logo from "../../../assets/img/Logo.svg";
import Vezarat from "../../../assets/img/amoozesh-logo.png";
import Header from "common/components/Header/Header";
import { usePostOtpMutation } from "../../../api/auth.api";

function VerifyOtpCode({ onChange, value, reviseClick, onClick, status }: any) {
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("rgb(97, 97, 97)", "white");
  const navigate = useNavigate();
  // const verifyClickHandler = () => {
  //   // setSignUp(true);
  //   // setStep(2);
  //    //const { data, error, isLoading, isSuccess } = usePostOtpMutation();
  // };
  return (
    <Flex
      alignItems="center"
      justifyContent="start"
      style={{ userSelect: "none" }}
      w={{ md: "50%", lg: "42%", sm: "90%" }}
      mt={{
        base: "150px",
        "2xl": "150px",
        xl: "150px",
        md: "40px",
        sm: "40px",
      }}
      mb={{ "2xl": "40px" }}
      className="authCard"
    >
      <Flex direction="column" w="100%" background="transparent" p="30px">
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          className="header"
          mt="10px"
          mb="130px"
        >
          <img src={Logo} className="header-logo" />
          <img src={Vezarat} className="logo-text" />
          {/* <Header headerClass="header-logo" textClass="logo-text"/> */}
        </Flex>
        <Heading
          color={textColor}
          fontSize={{ base: "25px", xl: "25px", "2xl": "25px", sm: "20px" }}
          mb="20px"
        >
          کد ورود به سامانه
        </Heading>
        <FormControl>
          <Flex
            alignItems="center"
            justifyContent="center"
            className="otpFeild"
          >
            <HStack>
              <PinInput otp value={value} onChange={onChange}>
                <PinInputField borderColor="gray" />
                <PinInputField borderColor="gray" />
                <PinInputField borderColor="gray" />
                <PinInputField borderColor="gray" />
                <PinInputField borderColor="gray" />
                <PinInputField borderColor="gray" />
              </PinInput>
            </HStack>
          </Flex>

          <Flex justifyContent="space-between" mt="40px">
            {/* <NavLink to="/admin/dashboard"> */}
            <Button
              onClick={onClick}
              fontSize="15px"
              type="submit"
              bg="teal.300"
              w={{ xl: "150px", "2xl": "150px", sm: "100px" }}
              h="45"
              mb="20px"
              color="white"
              mt="20px"
              _hover={{
                bg: "teal.200",
              }}
              _active={{
                bg: "teal.400",
              }}
              isDisabled={status === "pending" ? true : false}
              isLoading={status === "pending" ? true : false}
            >
              ورود
            </Button>
            {/* </NavLink> */}

            <Button
              onClick={reviseClick}
              fontSize="15px"
              type="submit"
              colorScheme="blue"
              w={{ xl: "150px", "2xl": "150px", sm: "100px" }}
              h="45"
              mb="20px"
              color="white"
              mt="20px"
              // _hover={{
              //   bg: "teal.200",
              // }}
              // _active={{
              //   bg: "teal.400",
              // }}
            >
              ویرایش
            </Button>
          </Flex>
        </FormControl>
      </Flex>
    </Flex>
  );
}

export default VerifyOtpCode;
